import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TableWrapper = styled.div`
  width: fit-content;
  overflow-x: auto;
`;

const tableColumns = [
  {
    columns: [
      {
        Header: 'Type',
        accessor: 'type',
        width: 200,
      },
      {
        Header: '% of Completion',
        accessor: 'completion_percentage',
        width: 200,
      },
      {
        Header: '% of Student',
        accessor: 'students_percentage',
        width: 200,
      },
      {
        accessor: 'order',
        width: 0,
        show: false,
      },
    ],
  },
];

class OptionalSheetTable extends PureComponent {
  render() {
    const { optionalSheetsData } = this.props;
    const sortByPosition = [{ id: 'order', desc: false }];

    return (
      <TableWrapper>
        <ReactTable
          className="-striped -highlight"
          columns={tableColumns}
          data={optionalSheetsData}
          defaultPageSize={optionalSheetsData.length}
          defaultSorted={sortByPosition}
          style={{ textAlign: 'center' }}
        />
      </TableWrapper>
    );
  }
}

OptionalSheetTable.propTypes = {
  optionalSheetsData: PropTypes.arrayOf(PropTypes.shape({})),
};

OptionalSheetTable.defaultProps = {
  optionalSheetsData: null,
};

export default OptionalSheetTable;
